<div [className]="'chat-list-container'">
    <button rel="tooltip" type="button" class="btn btn-action float-right close-button" (click)="closePopUp()">
        <i class="material-icons">close</i>
    </button>
    <span [className]="'chat-dialog-header'">Empezar nuevo chat con:</span>

    <div [className]="'chat-list-search-container'">
        <div [className]="'chat-list-search-text-container'">
            <input type="text" [className]="'chat-list-search-text'" [(ngModel)]="searchQuery"
                (ngModelChange)="filterChats()" placeholder="Buscar">
        </div>
    </div>
    <div [className]="'chat-list-scroll-container'">
        <div *ngFor="let newChat of filteredData" [className]="'chat-list-dialog-card'">

            <div [className]="'chat-list-dialog-card-content'" (click)="openChat(newChat)">
                <div *ngIf="!newChat.profileImage" [className]="'chat-list-dialog-card-initials'">
                    {{newChat.initials}}
                </div>

                <img *ngIf="newChat.profileImage" alt="profile-img"
                    [src]="'data:image/png;base64,' + newChat.profileImage.imageData"
                    [ngClass]="'chat-list-dialog-card-image'" />

                <div [className]="'chat-list-dialog-card-text-container'">
                    <span [className]="'chat-list-dialog-card-text-name'">{{newChat.fullName}}</span>
                    <span [className]="'chat-list-dialog-card-text-company'">{{newChat.company.name}}</span>
                    <span [className]="'chat-list-dialog-card-text-position'">{{newChat.userType}}</span>
                </div>
            </div>
        </div>
    </div>
</div>